import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ModalModule} from "../../../../../components/common/modal/modal.module";
import {ProductSaveModule} from "../product-save/product-save.module";
import {ProductSaveModalComponent} from "./product-save-modal.component";
import {DialogModule} from '../../../../common/dialog/dialog.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ModalModule,
        ProductSaveModule,
        DialogModule,
    ],
    declarations: [
        ProductSaveModalComponent
    ],
    exports: [
        ProductSaveModalComponent,
    ],
})
export class ProductSaveModalModule {
}
